import React from "react";
import globalStyles from "../../styles/globalStyles.module.css";
import styles from "./Home.module.css";
import { useExploreContext } from "../../context/ExploreProvider";
import InfiniteScroll from "../../components/InfiniteScroll/InfiniteScroll";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// interface Profile {
//   id: number;
//   name: string;
//   image: string;
// }

const Home: React.FC = () => {
  const { exploreState } = useExploreContext();
  const { t } = useTranslation();

  return (
    <div>
      <div className={globalStyles.pageTitle}>{t("explore.label")}</div>
      <InfiniteScroll
        key={3}
        togglePage={exploreState.togglePage}
        loading={exploreState.loading}
        hasMore={exploreState.hasMore}
      >
        {exploreState.data.length === 0 ? (
          <div className={globalStyles.center}>{t("noContent")}</div>
        ) : (
          exploreState.data.map((item, index) => (
            <div key={index}>
              <div className={styles.item}>
                <div className={styles.header}>
                  <div className={styles.creator}>
                    <Link
                      to={`/profile/${item.username}`}
                      className={styles.profileRedirect}
                    >
                      <img
                        alt="profile_picture"
                        className={styles.profileImage}
                        src={item?.profile_image_url}
                      />
                    </Link>
                  </div>
                  <div>
                    <div>
                      <Link
                        to={`/profile/${item.username}`}
                        className={styles.profileRedirect}
                      >
                        <strong>{item.username} </strong>
                      </Link>
                      {t("explore.activity.createdWithCards", {
                        count: item.cards.length,
                      })}
                    </div>
                    <small>
                      {new Date(item.updated_at).toLocaleString(undefined, {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: undefined,
                      })}
                    </small>
                  </div>
                </div>
                <Link
                  to={`/boosters/${item.booster_id}`}
                  className={styles.profileRedirect}
                >
                  <div className={styles.itemBody}>
                    <div>
                      <div className={styles.boosterInfo}>
                        <img
                          src={item.booster_image_url}
                          alt="booster_image"
                          className={styles.boosterImage}
                        />
                        <div>
                          <h6>{item.booster_name}</h6>
                          <div>{item.booster_description}</div>
                        </div>
                      </div>
                      <div className={styles.cardRow}>
                        {item.cards.map((url, index) => (
                          <img
                            key={index}
                            src={url}
                            alt="card_image"
                            className={styles.cardImage}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <hr />
            </div>
          ))
        )}
      </InfiniteScroll>
    </div>
  );
};

export default Home;
